/**
 * Registers all built-in layout components in the renderer registry.
 *
 * Call this once at app startup (before any layout is rendered) to make
 * primitives and composite components available to the rendering engine.
 */

import { registerRenderer } from "./registry";
import LayoutText from "./components/LayoutText";
import LayoutImage from "./components/LayoutImage";
import LayoutVideo from "./components/LayoutVideo";
import LayoutShape from "./components/LayoutShape";
import LayoutBarLoader from "./components/LayoutBarLoader";
import LayoutQRCode from "./components/LayoutQRCode";
import LayoutIcon from "./components/LayoutIcon";

let initialized = false;

export function setupRegistry(): void {
  if (initialized) return;
  initialized = true;

  registerRenderer("primitive:text", { component: LayoutText as any });
  registerRenderer("primitive:image", { component: LayoutImage as any });
  registerRenderer("primitive:video", { component: LayoutVideo as any });
  registerRenderer("primitive:shape", { component: LayoutShape as any });
  registerRenderer("component:barLoader", {
    component: LayoutBarLoader as any,
  });
  registerRenderer("component:qrCode", {
    component: LayoutQRCode as any,
  });
  registerRenderer("component:icon", {
    component: LayoutIcon as any,
  });
}
